import { Text as MantineText } from "@mantine/core";
export const Text = MantineText.extend({
  styles: {
    root: {
      wordBreak: "break-word",
    },
  },
});
